import type { ReceiptTemplate } from '../schema';

export const hardeesTemplate: ReceiptTemplate = {
  id: 'hardees',
  name: "Hardee's Receipt",
  brand: "HARDEE'S",
  description: "Hardee's fast food receipt",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'hardees-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: "HARDEE'S",
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hardees-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 12:30 PM\nORDER #847',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'hardees-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'THICKBURGER COMBO', quantity: '1', price: '9.99', sku: '' },
          { id: '2', name: 'CURLY FRIES LG', quantity: '1', price: '3.49', sku: '' },
          { id: '3', name: 'COKE LG', quantity: '1', price: '2.49', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hardees-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '15.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.32', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '17.29', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hardees-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hardees-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU!\nPLEASE COME AGAIN',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

